<common-ui-components-page-layout
  [title]="'لیست تراکنش‌ها'"
  [showBorder]="false"
  [hasBackAction]="false"
  (onBackAction)="backToTransactionHomePage()"
>
  <common-ui-components-tab-group [tabs]="tabs"></common-ui-components-tab-group>
</common-ui-components-page-layout>
